import { clx } from "@modules/common/components/ui"

/**
 * Small red "SALE" badge to highlight discounted products on cards/images.
 * Shown only when a product is on a sale price list. Optionally renders the
 * discount percentage (e.g. "50% OFF").
 */
export default function SaleTag({
  percent,
  className,
}: {
  percent?: number
  className?: string
}) {
  return (
    <span
      className={clx(
        "z-10 inline-flex items-center bg-[#c0392b] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-white shadow-sm",
        className
      )}
      data-testid="sale-tag"
    >
      {percent && percent > 0 ? `${percent}% OFF` : "Sale"}
    </span>
  )
}
